import { render, staticRenderFns } from "./DeviceNotes.vue?vue&type=template&id=d5c558dc"
import script from "./DeviceNotes.vue?vue&type=script&lang=ts"
export * from "./DeviceNotes.vue?vue&type=script&lang=ts"
import style0 from "./DeviceNotes.vue?vue&type=style&index=0&id=d5c558dc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports